import { createPermission } from '@backstage/plugin-permission-common';

export const adminCreatePermission = createPermission({
  name: 'admin.entity.create',
  attributes: { action: 'create' },
});

export const adminReadPermission = createPermission({
  name: 'admin.entity.read',
  attributes: { action: 'read' },
});

export const adminUpdatePermission = createPermission({
  name: 'admin.entity.update',
  attributes: { action: 'update' },
});

export const adminDeletePermission = createPermission({
  name: 'admin.entity.delete',
  attributes: { action: 'delete' },
});

export const adminPermissions = [
  adminCreatePermission,
  adminReadPermission,
  adminUpdatePermission,
  adminDeletePermission,
];

export const catalogProviderUpdatePermission = createPermission({
  name: 'catalog.provider.update',
  attributes: { action: 'update' },
});

export const catalogScanPermission = createPermission({
  name: 'catalog.inventory.update',
  attributes: { action: 'update' },
});

export const projectAccountCreatePermission = createPermission({
  name: 'project.account.create',
  attributes: { action: 'create' },
});

export const projectAccountReadPermission = createPermission({
  name: 'project.account.read',
  attributes: { action: 'read' },
});

export const projectAccountUpdatePermission = createPermission({
  name: 'project.account.update',
  attributes: { action: 'update' },
});

export const projectAccountDeletePermission = createPermission({
  name: 'project.account.delete',
  attributes: { action: 'delete' },
});

export const projectAccountPermissions = [
  projectAccountCreatePermission,
  projectAccountReadPermission,
  projectAccountUpdatePermission,
  projectAccountDeletePermission,
];

export const projectClusterCreatePermission = createPermission({
  name: 'project.cluster.create',
  attributes: { action: 'create' },
});

export const projectClusterReadPermission = createPermission({
  name: 'project.cluster.read',
  attributes: { action: 'read' },
});

export const projectClusterUpdatePermission = createPermission({
  name: 'project.cluster.update',
  attributes: { action: 'update' },
});

export const projectClusterDeletePermission = createPermission({
  name: 'project.cluster.delete',
  attributes: { action: 'delete' },
});

export const projectClusterPermissions = [
  projectClusterCreatePermission,
  projectClusterReadPermission,
  projectClusterUpdatePermission,
  projectClusterDeletePermission,
];

export const projectIntegrationCreatePermission = createPermission({
  name: 'project.integration.create',
  attributes: { action: 'create' },
});

export const projectIntegrationReadPermission = createPermission({
  name: 'project.integration.read',
  attributes: { action: 'read' },
});

export const projectIntegrationUpdatePermission = createPermission({
  name: 'project.integration.update',
  attributes: { action: 'update' },
});

export const projectIntegrationDeletePermission = createPermission({
  name: 'project.integration.delete',
  attributes: { action: 'delete' },
});

export const projectIntegrationPermissions = [
  projectIntegrationCreatePermission,
  projectIntegrationReadPermission,
  projectIntegrationUpdatePermission,
  projectIntegrationDeletePermission,
];
